import { __module as o } from "./ghl-ui.es1681.js";
import { i as p } from "./ghl-ui.es1541.js";
import { _ as u } from "./ghl-ui.es1682.js";
import { r as d } from "./ghl-ui.es1637.js";
(function(s, t) {
  var a = p.default;
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = f;
  var n = a(u), i = a(d);
  function f(e) {
    (0, i.default)(1, arguments);
    var r = Object.prototype.toString.call(e);
    return e instanceof Date || (0, n.default)(e) === "object" && r === "[object Date]" ? new Date(e.getTime()) : typeof e == "number" || r === "[object Number]" ? new Date(e) : ((typeof e == "string" || r === "[object String]") && typeof console < "u" && (console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments"), console.warn(new Error().stack)), /* @__PURE__ */ new Date(NaN));
  }
  s.exports = t.default;
})(o, o.exports);
var D = o.exports;
export {
  D as t
};
